import FontAwesome from '@vromo/ui/components/FontAwesome';
import Tooltip from '@vromo/ui/components/Tooltip';
import format from 'date-fns/format';
import isThisYear from 'date-fns/is_this_year';
import capitalize from 'lodash/capitalize';
import React, { ReactElement, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DispatchHistoryItem } from '../../../../helpers/JobHistoryHelper';
import styles from './auditHistoryItem.style';

interface Props {
    dispatch: DispatchHistoryItem;
}

const AuditHistoryItem = ({ dispatch }: Props): ReactElement => {
    const { t } = useTranslation();
    const translate = (key: string) => t(`jobHistory.${key}`);
    const { created, dispatchAudit, dispatchType, overflowReturnReason } = dispatch;
    
    const tooltipText = useMemo(() => {
        try {
            if(!overflowReturnReason) return overflowReturnReason;
            return JSON.parse(overflowReturnReason)?.message || overflowReturnReason;
        } catch (e) {
            return overflowReturnReason;
        }
    }, [overflowReturnReason]);

    const date = format(created!, `DD MMM ${isThisYear(created!) ? '' : 'YYYY'} HH:mm `);
    const auditContact = dispatchAudit?.user?.contact;
    const auditUserName = (auditContact?.name || auditContact?.email || translate('unknownUser'));

    const auditUser =
        dispatchAudit && dispatchAudit.type.toLowerCase() !== 'auto'
            ? `${translate('by')} ${auditUserName} (${capitalize(dispatchAudit.type)})`
            : `(${capitalize(dispatchAudit?.type)})`;

    const driverContact = dispatch.vehicle?.driver?.contact;
    const driverName = (driverContact?.name || driverContact?.email || translate('unknownUser'));

    const driver =
        dispatchType &&
        ['dispatched', 'returned'].includes(dispatchType.toLowerCase()) ?
        ` ${translate(dispatchType.toLowerCase() === 'dispatched' ? 'to' : 'from')} ${driverName}` : '';

    const auditText = `${date}${auditUser}`;

    return (
        <div key={dispatch.id} className={styles.container}>
            <div className={styles.contentContainer}>
                <strong className={styles.dispatchType}>{capitalize(dispatchType)}</strong>
                {driver}
                {!!tooltipText && (
                    <Tooltip position="bottom" label={tooltipText}>
                        <div className={styles.iconContainer}>
                            <FontAwesome icon="info-circle" />
                        </div>
                    </Tooltip>
                )}
            </div>
            <div className={styles.auditText}>{auditText}</div>
        </div>
    );
};

export default AuditHistoryItem;
